export const plateFormat = (value: string) =>
  value
    .replace(/[^0-9a-zA-Z]+/gi, '')
    .slice(0, 7)
    .toUpperCase();
